export enum GapiLicense {
    AcquiringCCProccessing = 'AcquiringCCProccessing', // Payment Active License
    ExternalConsumerPortal = 'ExternalConsumerPortal',
    ConsumerPortalTracking = 'ConsumerPortalTracking'
}

// Typing for the enum
export type GapiLicenseType = keyof typeof GapiLicense;
